<template>
  <v-table class="stops-table">
    <thead>
      <tr>
        <th class="text-left">Halt</th>
        <!-- Below sm the headers, not the times, set the minimum width of these
             columns, so abbreviating them buys the Halt column ~30px. -->
        <th class="text-left"><span class="d-none d-sm-inline">Ankunft</span><span class="d-sm-none">An</span></th>
        <th class="text-left"><span class="d-none d-sm-inline">Abfahrt</span><span class="d-sm-none">Ab</span></th>
        <th class="text-left d-none d-sm-table-cell" v-if="hasVehicles">Fahrzeug</th>
        <th class="text-left d-none d-sm-table-cell">Störungen</th>
        <th class="text-left d-none d-sm-table-cell">Trend</th>
      </tr>
    </thead>
    <tbody>
      <TrainStop :stop="item" :previousStop="stops[index - 1]" :hasVehicles="hasVehicles" v-for="(item, index) in stops" :key="item.id" />
    </tbody>
  </v-table>
</template>

<script>
import TrainStop from './Stop.vue'

export default {
  name: 'Stops',
  props: ['stops', 'hasVehicles'],

  components: {
    TrainStop,
  },
};
</script>

<style scoped>
/* The selectors below mirror Vuetify's own cell selectors and add `.stops-table`
   so they win on specificity — matching them exactly would only tie, and
   Vuetify's stylesheet is emitted last. */

/* Many DB station names are a single unbreakable token ("Frankfurt(Main)Hbf"),
   which sets a hard min-width the Halt column cannot go below — that is what
   pushed the Abfahrt column out of the (horizontally scrollable, so silently
   clipped) table wrapper on phones. `anywhere` rather than `break-word`: only
   `anywhere` also shrinks min-content, which is what table sizing uses. */
.stops-table :deep(.v-table__wrapper > table > tbody > tr > td:first-child) {
  overflow-wrap: anywhere;
}

/* Vuetify's 16px cell padding costs 32px per column, which the narrow viewports
   cannot spare: below md the table is the widest thing on the page. */
@media (max-width: 767.98px) {
  .stops-table :deep(.v-table__wrapper > table > thead > tr > th),
  .stops-table :deep(.v-table__wrapper > table > tbody > tr > td) {
    padding: 0 8px;
  }
}
</style>
